/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../support/utils';
import {
  GET_CONVERSION_VALUE_MAPPING,
  UPDATE_CONVERSION_VALUE_MAPPING,
  DELETE_CONVERSION_VALUE_MAPPING,
  UPDATE_SK_AD_NETWORK_ENABLED_EDIT,
  SAVE_SK_AD_NETWORK_CONFIGURATION,
  CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES,
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING,
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS,
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR,
  FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS,
  GET_SKAN_AD_PARTNERS,
  UPDATE_ENFORCE_CONVERSION_VALUE_MAPPING_HIGHEST_VALUE,
} from '../actions/SKAdnetworkAction';
import type { SKAdnetworkReducer, ConversionValueMapping } from '../types/skadnetworkTypes';
import { sortByCompanyName } from './AdPartnerReducer';
const INIT_STATE: SKAdnetworkReducer = {
  availableCampaignsForSANAdPartners: undefined,
  isLoadingAvailableCampaignsForSANAdPartners: true,
  conversionValueMapping: undefined,
  conversionValueMappingRevisions: [],
  skAdNetworkEnabledEdit: undefined,
  updatingAdPartnersForSKANAgencyPermissions: false,
  enforceHighestConversionValue: undefined,
  adPartnersForSKAN: [],
  loading: false,
  error: null,
};

function getEnforceHighestConversionValue(mapping: ConversionValueMapping) {
  const mandatoryConversionMappingIndex = '0';
  return mapping[mandatoryConversionMappingIndex]?.enforceHighestConversionValue;
}

function Handler(state, action) {
  switch (action.type) {
    case GET_CONVERSION_VALUE_MAPPING.response:
      return {
        ...state,
        conversionValueMapping: action.data,
        enforceHighestConversionValue: getEnforceHighestConversionValue(action.data),
      };

    case UPDATE_CONVERSION_VALUE_MAPPING:
    case DELETE_CONVERSION_VALUE_MAPPING:
      return { ...state, conversionValueMappingRevisions: [...state.conversionValueMappingRevisions, action.data] };

    case UPDATE_SK_AD_NETWORK_ENABLED_EDIT:
      return { ...state, skAdNetworkEnabledEdit: action.data };

    case UPDATE_ENFORCE_CONVERSION_VALUE_MAPPING_HIGHEST_VALUE:
      return { ...state, enforceHighestConversionValue: action.data, enforceHighestConversionValueChanged: true };

    case SAVE_SK_AD_NETWORK_CONFIGURATION.response:
      return {
        ...INIT_STATE,
        conversionValueMapping: action.data.updatedConversionValueMapping,
        enforceHighestConversionValue: getEnforceHighestConversionValue(action.data.updatedConversionValueMapping),
        enforceHighestConversionValueChanged: false,
      };

    case CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES:
      return { ...state, conversionValueMappingRevisions: [], skAdNetworkEnabledEdit: undefined };

    case UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING:
      return { ...state, updatingAdPartnersForSKANAgencyPermissions: true };

    case UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS:
    case UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR:
      return { ...state, updatingAdPartnersForSKANAgencyPermissions: false };

    case FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS.response:
      return {
        ...state,
        availableCampaignsForSANAdPartners: action.data,
        isLoadingAvailableCampaignsForSANAdPartners: false,
      };

    case FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS.error:
      return { ...state, isLoadingAvailableCampaignsForSANAdPartners: false };

    case GET_SKAN_AD_PARTNERS.response:
      return { ...state, adPartnersForSKAN: sortByCompanyName(action.data.partners), loading: false };

    default:
      return state;
  }
}

export default reducerWrapper(INIT_STATE, Handler, {
  request: [FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS, GET_SKAN_AD_PARTNERS],
  error: [FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS, GET_SKAN_AD_PARTNERS],
  resetOn: ['APP_CHANGE'],
});
